import { Body } from '@/components/Voucher/styles';
import { apiLoja } from '@/services/api';
import { COUPON_POLES_SET, COUPON_POLES_LOADING, COUPON_POLES_LOADED, COUPON_POLE_UPDATE } from '../actionTypes';
import * as _ from 'lodash';


export const setCouponPoles = (couponsPole, isPolesOnCoupon) => ({
    type: COUPON_POLES_SET,
    payload: { couponsPole, isPolesOnCoupon },
});

export const loadingCouponPoles = () => ({
    type: COUPON_POLES_LOADING,
});

export const loadedCouponPoles = () => ({
    type: COUPON_POLES_LOADED,
});

export const fetchAllPolesCouponLoja = (IdCupom) => {
    return (dispatch, getState) => {
        dispatch(loadingCouponPoles());
        const state = getState();
        const user = state.user.user;
        const IdFranqueadora = user.IdFranqueadora;

        apiLoja
            .get(`/CupomPolo/GetAllCupomPoloByIdCupom/${IdCupom}/${IdFranqueadora}`)
            .then((data) => {
                if (data.data) {
                    const ordered = _.orderBy(data.data, 'Ativo', 'desc');
                    const isPolesOnCoupon = _.find(ordered, { Ativo: true }) || false;

                    if (isPolesOnCoupon) {
                        dispatch(setCouponPoles(ordered, true));
                    } else {
                        dispatch(setCouponPoles(ordered, false));
                    }
                }
                dispatch(loadedCouponPoles());
            })
            .catch((error) => {
                console.log('error comming', error);
            });
    };
};

export const fetchCouponPolesLoja = (couponPole) => {
    return (dispatch) => {
        dispatch(loadingCouponPoles());
        apiLoja
            .get(`/CupomPolo/GetCupomPolo/${couponPole.IdCupom}/${couponPole.IdPolo}`)

            .then((data) => {
                if (data.data) {
                    dispatch(updateCouponPole(couponPole));
                }
                else {
                    dispatch(addCouponPoles(couponPole));
                }
            })
            .catch((error) => {
                console.log('error comming', error);
                dispatch(loadedCouponPoles());
            });
    };
};

export const updateCouponPoleLocal = (pole) => ({
    type: COUPON_POLE_UPDATE,
    payload: pole,
});

export const addCouponPoles = (data) => {
    return (dispatch) => {
        dispatch(loadingCouponPoles());
        apiLoja
            .post(`/CupomPolo/AddCupomPoloByIdCupom`, [data])
            .then(() => {
                dispatch(updateCouponPoleLocal(data));
                dispatch(loadedCouponPoles());
            })
            .catch((error) => {
                console.log('error comming', error);
                dispatch(loadedCouponPoles());
            });
    };
};

export const updateCouponPole = (couponPole) => {
    return (dispatch) => {
        dispatch(loadingCouponPoles());
        apiLoja
            .put(`/CupomPolo`, {
                ...couponPole,
            })
            .then((data) => {
                dispatch(updateCouponPoleLocal(couponPole));
                dispatch(loadedCouponPoles());
            })
            .catch((error) => {
                console.log('error comming', error);
                dispatch(loadedCouponPoles());
            });
    };
};

